"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ExpandCollapse = _interopRequireDefault(require("../ExpandCollapse"));
var _Item = _interopRequireDefault(require("./Item"));
var _ItemsGroup = _interopRequireDefault(require("./ItemsGroup"));
var _ThemeProvider = require("../ThemeProvider");
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function selectBorderStyles(tokens) {
  return {
    borderBottomWidth: tokens.borderWidth,
    borderBottomStyle: tokens.borderStyle,
    borderBottomColor: tokens.borderColor
  };
}
const [selectProps, selectedSystemPropTypes] = (0, _utils.selectSystemProps)([_utils.a11yProps, _utils.viewProps]);

/**
 ## Usage Criteria
 - Use in conjunction with a large amount of educational / informational content
 - Allow the user to navigate between options frequently and efficiently
 */
const SideNav = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    children,
    variant = {},
    tokens,
    accordion = true,
    itemTokens,
    groupTokens,
    ...rest
  } = _ref;
  const themeTokens = (0, _ThemeProvider.useThemeTokens)('SideNav', tokens, variant);
  const [active, setActive] = _react.default.useState({
    groupId: undefined,
    itemId: undefined
  });
  const onItemPress = (itemId, groupId) => {
    setActive({
      itemId,
      groupId
    });
  };
  const isItemActive = (itemId, groupId) => {
    return active.groupId === groupId && active.itemId === itemId;
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ExpandCollapse.default, {
    ref: ref,
    maxOpen: accordion ? 1 : null,
    style: selectBorderStyles(themeTokens),
    ...selectProps(rest),
    children: _ref2 => {
      let {
        openIds,
        onToggle
      } = _ref2;
      const renderItem = (item, index, groupId) => {
        const {
          itemId = `item-${index}`,
          onPress
        } = item.props;
        const handlePress = function () {
          onItemPress(...arguments);
          if (onPress) onPress(...arguments);
        };
        return /*#__PURE__*/(0, _react.createElement)(_Item.default, {
          ...item.props,
          key: itemId,
          itemId: itemId,
          groupId: groupId,
          variant: groupId ? {
            ...variant,
            type: 'child'
          } : variant,
          tokens: itemTokens,
          isActive: isItemActive(itemId, groupId),
          onPress: handlePress
        });
      };
      return _react.default.Children.map(children, (child, index) => {
        // iterate over children and identify them internally to later reference expanded groups and active items
        if (child.type === _Item.default) return renderItem(child, index);
        if (child.type === _ItemsGroup.default) {
          const {
            groupId = `group-${index}`
          } = child.props;
          const isGroupActive = active.itemId !== undefined && active.groupId === groupId;
          const handleToggle = event => onToggle(groupId, event);
          return /*#__PURE__*/(0, _react.createElement)(_ItemsGroup.default, {
            ...child.props,
            key: groupId,
            groupId: groupId,
            variant: variant,
            tokens: groupTokens,
            itemTokens: itemTokens,
            openGroups: openIds,
            isActive: isGroupActive,
            onToggle: handleToggle
          }, _react.default.Children.map(child.props.children, (item, itemIndex) => renderItem(item, itemIndex, groupId)));
        }
        return null;
      });
    }
  });
});
SideNav.displayName = 'SideNav';
SideNav.propTypes = {
  ...selectedSystemPropTypes,
  /**
   * Specifies the structure and links of the `SideNav`. It may only consist of `SideNav.Item` and `SideNav.ItemsGroup`.
   */
  children: (0, _utils.componentPropType)(['Item', 'ItemsGroup']),
  /**
   * Identifies if only one `SideNav.ItemsGroup` should be open at a time.
   */
  accordion: _propTypes.default.bool,
  variant: _utils.variantProp.propType,
  tokens: (0, _utils.getTokensPropType)('SideNav'),
  /**
   * Custom tokens for `SideNav.Item`
   */
  itemTokens: (0, _utils.getTokensPropType)('SideNavItem'),
  /**
   * Custom tokens for `SideNavItemsGroup`
   */
  groupTokens: (0, _utils.getTokensPropType)('SideNavItemsGroup')
};
SideNav.Item = _Item.default;
SideNav.ItemsGroup = _ItemsGroup.default;
var _default = exports.default = SideNav;